import Configurations = require("Presentation/Scripts/TFS/TFS.Configurations");
import BoardsSettingsControls = require("Agile/Scripts/Board/BoardsSettingsControls");
import CardAnnotationCustomizationView = require("Agile/Scripts/Card/CardCustomizationAnnotationView");
import CardTestsCustomizationView = require("Agile/Scripts/Card/CardCustomizationTestsView");
import CardStyleCustomization_NO_REQUIRE = require("Agile/Scripts/Card/CardCustomizationStyle");
import CardStyleCustomizationView = require("Agile/Scripts/Card/CardCustomizationStyleView");
import CardTagColorCustomizationView = require("Agile/Scripts/Card/CardCustomizationTagColorView");
import { BoardAnnotationsIdentifier } from "Agile/Scripts/BoardAnnotationsIdentifier";
import { TabControlsRegistrationConstants } from "Agile/Scripts/Common/Agile";

export function registerCardSettings(
  fieldOptions: BoardsSettingsControls.IFieldSettingsControlOptions,
  styleOptions: CardStyleCustomization_NO_REQUIRE.ICardStyleSettingsCSCControlInitOptions,
  tagOptions: CardStyleCustomization_NO_REQUIRE.ICardStyleSettingsCSCControlInitOptions,
  annotationOptions?: CardStyleCustomization_NO_REQUIRE.ICardStyleSettingsCSCControlInitOptions
) {
  if (!fieldOptions && !styleOptions && !tagOptions && !annotationOptions) {
    return;
  }

  Configurations.TabControlsRegistration.registerTabGroup({
    tabControlId:
      TabControlsRegistrationConstants.COMMON_CONFIG_SETTING_INSTANCE_ID,
    id: TabControlsRegistrationConstants.CARDS_GROUP_ID,
    title: TabControlsRegistrationConstants.CARDS_GROUP_TITLE,
    order: 10
  });

  if (fieldOptions) {
    registerCardFieldSettingsTab(fieldOptions);
  }
  if (styleOptions) {
    registerCardsStylesSettingTab(styleOptions);
  }
  if (tagOptions) {
    registerCardsTagColorSettingTab(tagOptions);
  }

  if (annotationOptions) {
    registerCardsAnnotationSettingTab(annotationOptions);
    registerCardsTestsTab(annotationOptions);
  }
}

function registerCardFieldSettingsTab(
  fieldOptions: BoardsSettingsControls.IFieldSettingsControlOptions
) {
  var cardFieldRegistrationOptions: Configurations.ITabRegistration<
    BoardsSettingsControls.IFieldSettingsControlOptions
    > = {
    groupId: TabControlsRegistrationConstants.CARDS_GROUP_ID,
    id: TabControlsRegistrationConstants.FIELDS_TAB_ID,
    title: TabControlsRegistrationConstants.FIELDS_TAB_TITLE,
    tabContent: BoardsSettingsControls.FieldSettingsControl,
    tabContentOptions: fieldOptions,
    order: 10
  };

  Configurations.TabControlsRegistration.registerTab(
    cardFieldRegistrationOptions
  );
}

function registerCardsAnnotationSettingTab(
  annotationOptions: CardStyleCustomization_NO_REQUIRE.ICardStyleSettingsCSCControlInitOptions
) {
  var cardAnnotationRegistrationOptions: Configurations.ITabRegistration<
    CardStyleCustomization_NO_REQUIRE.ICardStyleSettingsCSCControlInitOptions
    > = {
    groupId: TabControlsRegistrationConstants.CARDS_GROUP_ID,
    id: TabControlsRegistrationConstants.CARDS_ANNOTATION_TAB_ID,
    title: TabControlsRegistrationConstants.CARDS_ANNOTATION_TAB_TITLE,
    tabContent: CardAnnotationCustomizationView.ConfigureAnnotationsCSCControl,
    tabContentOptions: annotationOptions,
    order: 40
  };

  Configurations.TabControlsRegistration.registerTab(
    cardAnnotationRegistrationOptions
  );
}

function registerCardsTestsTab(
  annotationOptions: CardStyleCustomization_NO_REQUIRE.ICardStyleSettingsCSCControlInitOptions
) {
  let shouldRegister = false;
  $.each(
    annotationOptions.styleRules,
    (index, rule: CardStyleCustomization_NO_REQUIRE.IBaseStyleRule) => {
      if (rule.name === BoardAnnotationsIdentifier.TestAnnotation) {
        shouldRegister = true;
      }
    }
  );

  if (!shouldRegister) {
    return;
  }

  var cardTestsRegistrationOptions: Configurations.ITabRegistration<
    CardStyleCustomization_NO_REQUIRE.ICardStyleSettingsCSCControlInitOptions
    > = {
    groupId: TabControlsRegistrationConstants.CARDS_GROUP_ID,
    id: TabControlsRegistrationConstants.CARDS_TESTS_TAB_ID,
    title: TabControlsRegistrationConstants.CARDS_TESTS_TAB_TITLE,
    tabContent: CardTestsCustomizationView.ConfigureTestsCSCControl,
    tabContentOptions: annotationOptions,
    order: 50
  };

  Configurations.TabControlsRegistration.registerTab(
    cardTestsRegistrationOptions
  );
}

function registerCardsTagColorSettingTab(
  cardOptions: CardStyleCustomization_NO_REQUIRE.ICardStyleSettingsCSCControlInitOptions
) {
  var cardTabColorRegistrationOptions: Configurations.ITabRegistration<
    CardStyleCustomization_NO_REQUIRE.ICardStyleSettingsCSCControlInitOptions
    > = {
    groupId: TabControlsRegistrationConstants.CARDS_GROUP_ID,
    id: TabControlsRegistrationConstants.CARDS_TAGCOLOR_TAB_ID,
    title: TabControlsRegistrationConstants.CARDS_TAGCOLOR_TAB_TITLE,
    tabContent: CardTagColorCustomizationView.ConfigureTagColorsCSCControl,
    tabContentOptions: cardOptions,
    order: 30
  };

  Configurations.TabControlsRegistration.registerTab(
    cardTabColorRegistrationOptions
  );
}

function registerCardsStylesSettingTab(
  cardOptions: CardStyleCustomization_NO_REQUIRE.ICardStyleSettingsCSCControlInitOptions
) {
  var cardStylesRegistrationOptions: Configurations.ITabRegistration<
    CardStyleCustomization_NO_REQUIRE.ICardStyleSettingsCSCControlInitOptions
    > = {
    groupId: TabControlsRegistrationConstants.CARDS_GROUP_ID,
    id: TabControlsRegistrationConstants.CARDS_STYLES_TAB_ID,
    title: TabControlsRegistrationConstants.CARDS_STYLES_TAB_TITLE,
    tabContent: CardStyleCustomizationView.ConfigureStylesCSCControl,
    tabContentOptions: cardOptions,
    order: 20
  };

  Configurations.TabControlsRegistration.registerTab(
    cardStylesRegistrationOptions
  );
}
